import { Box, useTheme, Grid, Button, Paper, InputBase } from "@mui/material";
import ResponsiveDialog from "components/responsiveDialog";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import ReportTable, { RRow, RCell } from "components/Tables/ReportTable";
import { useEmployeeRolesList } from "api/hooks/humanResource";
import {requester} from "api/pesabackend";

export default function UserGroupsTable({ setIsSuccess }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [searchContent, setSearchContent] = useState("");
  const {employeeRoleList, isLoadingEmployeeRoleList, } = useEmployeeRolesList(1, business_branch_id)

  const handleClickEditOpen = async (e) => {
    try {
        const response = await requester.get(`/human_resource/employee_roles/${e.target.value}`);
        if (response.status === 200) {
            navigate("/userGroupPermissions", { state: response.data.data });
          } 
    } catch (e) {
    }
  };

  const handleClickEditClose = () => {
    setOpenEdit(false);
  };

  const handleClickDeleteClose = () => {
    setOpenDelete(false);
  };

  const handleClickDelete = async () => {
    
  };

  const handleSearchInput = async (e) => {
    setSearchContent(e.target.value);
  };

  const handleClickSearch = async () => {

  };

  return (
    <Box>
      <h4>User Groups List</h4>
      <Box p="1rem" m="1rem" borderRadius="0.5rem">
        <Grid container spacing={4} className="alignHorizantal">
          <Grid xs>
            <Paper
              sx={{
                my: "4px",
                p: "2px 4px",
                display: "flex",
                alignItems: "center",
                minWidth: 170,
                maxWidth: 300,
              }}
            >
              <InputBase
                placeholder="Search User Group Name"
                value={searchContent}
                onChange={handleSearchInput}
                sx={{ ml: 1, flex: 1 }}
              />
              <IconButton onClick={handleClickSearch}>
                <SearchIcon />
              </IconButton>
            </Paper>
          </Grid>
          <Grid xs>
            {/* <NativeSelectDemo
                inputName = "Filter By"
                itemOptions={filterOptions}
              /> */}
          </Grid>
          <Grid xs sx={{ textAlign: "right" }}>
            <Button variant="contained" onClick={()=>{
              navigate("/userGroup");
            }}>
              Add New User Group
            </Button>
          </Grid>
        </Grid>
      </Box>

      <ReportTable
        columns={[
          { label: "No.", width: 50 },
          { label: "Group Name", width: 170 },
          { label: "Actions", align: "center" },
        ]}
        rows={employeeRoleList}
        loading={isLoadingEmployeeRoleList}
        emptyMessage="No data found"
        renderRow={(row, index) => (
          <RRow key={row.id} index={index}>
            <RCell>{index + 1}</RCell>
            <RCell>{row.role_name}</RCell>
            <RCell align="center">
              <Button
                value={row.id}
                size="small"
                onClick={(e) => handleClickEditOpen(e)}
              >
                Edit{" "}
              </Button>

              <ResponsiveDialog
                dialogHeading="Edit"
                open={openEdit}
                handleClose={handleClickEditClose}
                negativeResponse="Cancel"
                content={
                  <Box
                    p="1rem"
                    borderRadius="0.5rem"
                    backgroundColor={theme.palette.background.alt}
                  >
                    {/* {<EditItemForm setOpen={setOpenEdit} setNewDepartmentRoleData={setNewDepartmentRoleData} id={clickedItem} editData={editData} setIsSuccess={setIsSuccess} />} */}
                  </Box>
                }
              />

              <ResponsiveDialog
                dialogHeading="Are you sure you want to delete?"
                open={openDelete}
                handleClose={handleClickDeleteClose}
                negativeResponse="Cancel"
                content={
                  <Box
                    p="1rem"
                    borderRadius="0.5rem"
                    backgroundColor={theme.palette.background.alt}
                  >
                    {
                      <Button
                        fullWidth
                        type="submit"
                        variant="contained"
                        onClick={handleClickDelete}
                        sx={{
                          m: "1rem 0",
                          p: "1rem",
                        }}
                      >
                        Yes, Delete
                      </Button>
                    }
                  </Box>
                }
              />
            </RCell>
          </RRow>
        )}
      />
    </Box>
  );
}
